module.exports = "/_next/static/images/ltc-9425ec4ecdfd181c64a89f38981ab953.png";